import React, { useState } from 'react';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import GridColumnSettingsDialog from './GridColumnSettingsDialog';

/**
 * 표 위 공통 툴바. 기존 화면들이 쓰던 fileName/showExport 는 그대로 동작한다.
 *
 * gridPersonalization 은 ResponsiveDataGrid 가 slotProps.toolbar 로 얹어 준다(컨테이너가 이 prop을
 * 직접 넘길 필요는 없다). ResponsiveDataGrid 로 옮긴 화면은 "열 설정" 다이얼로그(순서 바꾸기까지 겸함)가
 * MUI 기본 GridToolbarColumnsButton(칼럼 패널)을 대신한다. 아직 ResponsiveDataGrid 로 옮기지 않은 화면
 * (gridPersonalization 없음)은 기존 GridToolbarColumnsButton 을 그대로 보여준다 — bito는 ksm과 달리
 * 아직 전체 화면이 ResponsiveDataGrid로 이전되지 않았으므로, 이전 전/후 모두 칼럼 숨기기 기능을 잃지
 * 않도록 하는 안전한 기본값이다(2026-10-20 결정, 물어볼 것 아님).
 */
const CustomToolbar = ({ fileName, showExport, gridPersonalization }) => {
  const [columnDialogOpen, setColumnDialogOpen] = useState(false);
  const filterHidden = Boolean(gridPersonalization?.filterHidden);

  return (
    <GridToolbarContainer>
      {gridPersonalization ? (
        <Button size="small" startIcon={<ViewColumnIcon />} onClick={() => setColumnDialogOpen(true)}>
          열 설정
        </Button>
      ) : (
        <GridToolbarColumnsButton />
      )}
      {!filterHidden && <GridToolbarFilterButton />}
      <GridToolbarDensitySelector />
      {!showExport && (<GridToolbarExport
        csvOptions={{ fileName: fileName, utf8WithBom: true }}
      />)}
      <GridToolbarQuickFilter placeholder="표 안에서 검색" sx={{ ml: 'auto' }} />

      {gridPersonalization && (
        <GridColumnSettingsDialog
          open={columnDialogOpen}
          onClose={() => setColumnDialogOpen(false)}
          columns={gridPersonalization.columns}
          codeVisibilityModel={gridPersonalization.codeVisibilityModel}
          hidden={gridPersonalization.hidden}
          onApply={gridPersonalization.onApply}
          onReset={gridPersonalization.onReset}
        />
      )}
    </GridToolbarContainer>
  );
};

export default CustomToolbar;
